import { Typography } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import { formatNumber } from "accounting"
import classnames from "classnames"
import React, { Component } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import styles from "./styles"

class ShoutoutCard extends Component {
  render() {
    const { classes } = this.props

    const currencySymbol = this.props.event.currencyObj.symbol || "$"

    function shortenNumber(num) {
      if (num >= 100000) {
        return `${Math.floor(num / 1000)}k`
      }
      return formatNumber(num)
    }

    return (
      // BIDS
      <div key={this.props.index} className={classes.container}>
        {this.props.shoutout.hasOwnProperty("current_high_bid") && (
          <div
            className={classnames(classes.left, {
              [classes.leftIn]: true,
              [classes.isNewShoutout]:
                this.props.shoutout.hasOwnProperty("isNew") &&
                this.props.shoutout.isNew === true
            })}
          >
            <div className={classes.shoutoutCard}>
              {this.props.shoutout.hasOwnProperty("isNew") &&
              this.props.shoutout.isNew === true ? (
                  <React.Fragment>
                    <Typography classes={{ root: classes.newShoutoutStar }}>
                    New
                    </Typography>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography
                      classes={{
                        root: classes.newShoutoutStar
                      }}
                      style={{
                        color: "transparent"
                      }}
                    >
                    New
                    </Typography>
                  </React.Fragment>
                )}
              {!this.props.settings.hide_amount && (
                <div style={{ width: "50%" }}>
                  <Typography className={classes.number}>
                    <span>{currencySymbol}</span>
                    {shortenNumber(this.props.shoutout.current_high_bid)}
                  </Typography>
                </div>
              )}
              <div
                className={classes.nameTile}
                style={{
                  width: !this.props.settings.hide_amount ? "50%" : "100%",
                  marginLeft: !this.props.settings.hide_amount ? null : "24px"
                }}
              >
                <Typography className={classes.name}>
                  {this.props.shoutout.anon === "1" ||
                  this.props.nameStyle === "anonymous"
                    ? "Anonymous"
                    : this.props.shoutout[this.props.nameStyle]}
                </Typography>
                {!this.props.settings.spotlight && (
                  <Typography className={classes.thankYou}>
                    Thank you for your bid!
                  </Typography>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.shoutout.hasOwnProperty("donation_amt") && (
          // DONATIONS
          <div
            className={classnames(classes.left, {
              [classes.leftIn]: true,
              [classes.isNewShoutout]:
                this.props.shoutout.hasOwnProperty("isNew") &&
                this.props.shoutout.isNew === true
            })}
          >
            <div className={classes.shoutoutCard}>
              {this.props.shoutout.hasOwnProperty("isNew") &&
              this.props.shoutout.isNew === true ? (
                  <React.Fragment>
                    <Typography classes={{ root: classes.newShoutoutStar }}>
                    New
                    </Typography>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography
                      classes={{
                        root: classes.newShoutoutStar
                      }}
                      style={{
                        color: "transparent"
                      }}
                    >
                    New
                    </Typography>
                  </React.Fragment>
                )}
              {!this.props.settings.hide_amount && (
                <div style={{ width: "50%" }}>
                  <Typography className={classes.number}>
                    <span>{currencySymbol}</span>
                    {shortenNumber(this.props.shoutout.donation_amt)}
                  </Typography>
                </div>
              )}
              <div
                className={classes.nameTile}
                style={{
                  width: !this.props.settings.hide_amount ? "50%" : "100%",
                  marginLeft: !this.props.settings.hide_amount ? null : "24px"
                }}
              >
                <Typography className={classes.name}>
                  {this.props.shoutout.anon === "1" ||
                  this.props.nameStyle === "anonymous"
                    ? "Anonymous"
                    : this.props.shoutout[this.props.nameStyle]}
                  {this.props.nameStyle === "full_name" &&
                    this.props.shoutout.anon !== "1" &&
                    this.props.shoutout.user_name}
                </Typography>
                {!this.props.settings.spotlight && (
                  <Typography className={classes.thankYou}>
                    Thank you for your donation!
                  </Typography>
                )}
              </div>
            </div>
          </div>
        )}
        {this.props.shoutout.hasOwnProperty("purchase_amount") && (
          // FIXED PURCHASE
          <div
            className={classnames(classes.left, {
              [classes.leftIn]: true,
              [classes.isNewShoutout]:
                this.props.shoutout.hasOwnProperty("isNew") &&
                this.props.shoutout.isNew === true
            })}
          >
            <div className={classes.shoutoutCard}>
              {this.props.shoutout.hasOwnProperty("isNew") &&
              this.props.shoutout.isNew === true ? (
                  <React.Fragment>
                    <Typography classes={{ root: classes.newShoutoutStar }}>
                    New
                    </Typography>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <Typography
                      classes={{
                        root: classes.newShoutoutStar
                      }}
                      style={{
                        color: "transparent"
                      }}
                    >
                    New
                    </Typography>
                  </React.Fragment>
                )}
              {!this.props.settings.hide_amount && (
                <div div style={{ width: "50%" }}>
                  <Typography className={classes.number}>
                    <span>{currencySymbol}</span> {shortenNumber(this.props.shoutout.purchase_amount)}
                  </Typography>
                </div>
              )}
              <div
                className={classes.nameTile}
                style={{
                  width: !this.props.settings.hide_amount ? "50%" : "100%",
                  marginLeft: !this.props.settings.hide_amount ? null : "24px"
                }}
              >
                <Typography className={classes.name}>
                  {this.props.nameStyle === "anonymous"
                    ? "Anonymous"
                    : this.props.shoutout[this.props.nameStyle]}
                </Typography>
                {!this.props.settings.spotlight && (
                  <Typography className={classes.thankYou}>
                    Thank you for your purchase!
                  </Typography>
                )}
              </div>
            </div>
          </div>
        )}
        {!this.props.shoutout.hasOwnProperty("purchase_amount") &&
          !this.props.shoutout.hasOwnProperty("donation_amt") &&
          !this.props.shoutout.hasOwnProperty("current_high_bid") && (
            // RAFFLE PURCHASE
            <div
              className={classnames(classes.left, {
                [classes.leftIn]: true,
                [classes.isNewShoutout]:
                  this.props.shoutout.hasOwnProperty("isNew") &&
                  this.props.shoutout.isNew === true
              })}
            >
              <div className={classes.shoutoutCard}>
                {this.props.shoutout.hasOwnProperty("isNew") &&
                this.props.shoutout.isNew === true ? (
                    <React.Fragment>
                      <Typography classes={{ root: classes.newShoutoutStar }}>
                      New
                      </Typography>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <Typography
                        classes={{
                          root: classes.newShoutoutStar
                        }}
                        style={{
                          color: "transparent"
                        }}
                      >
                      New
                      </Typography>
                    </React.Fragment>
                  )}
                <div className={classes.nameTile}>
                  <Typography className={classes.name}>
                    {/* {this.state.currentData.user[this.props.data.settings.name_style]} */}
                    {this.props.nameStyle === "anonymous"
                      ? "Anonymous"
                      : this.props.shoutout[this.props.nameStyle]}
                  </Typography>

                  <Typography className={classes.thankYou}>
                    You are the winner of {this.props.shoutout.item_name}!
                  </Typography>
                </div>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default compose(
  connect(),
  withStyles(styles, { withTheme: true })
)(ShoutoutCard)



// WEBPACK FOOTER //
// ./src/components/ShoutoutCard/index.jsx